import { ISubscription } from "@/server/types/subscription";
import { safeSession } from "@/utils/safeStorage";

export type PendingAuthData = {
  username: string;
  derivedKey: string;
  token: string;
  refreshToken: string;
  privateKeys: string;
  publicKeys: string;
  encryptedPassword?: string;
  subscription?: ISubscription;
  pendingTcVersion: string;
  // KDF scheme captured at the gated login/register (0 = v1, 2 = v2, 3 = v3), so
  // the committed session records the right scheme after T&C acceptance.
  kdfVersion: number;
  // Per-user random salt (hex) for v3; "" for v1/v2.
  kdfSalt: string;
};

const KEY = "pending_auth";

export const savePendingAuth = (data: PendingAuthData): void => {
  safeSession.set(KEY, JSON.stringify(data));
};

export const loadPendingAuth = (): PendingAuthData | null => {
  const raw = safeSession.get(KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as PendingAuthData;
  } catch {
    return null;
  }
};

export const clearPendingAuth = (): void => {
  safeSession.remove(KEY);
};
